export const mainColor="#3980FD"